import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import {
  AxiosCustomGet,
  AxiosCustomPost,
} from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import AppRoutePath from "../../router/AppRoutePath";
import httpclient from "../../components/httpclient";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Upload, message, Button } from "antd";
import { FaLongArrowAltDown } from "react-icons/fa";
import { MdSave } from "react-icons/md";
import { IoCalendarOutline } from "react-icons/io5";
import { convertOutletList } from "./employee/list_employee/helpers/convertOutletList";
import { convertJabatanList } from "./employee/list_employee/helpers/convertJabatanList";
import { useHistory } from "react-router-dom";
import IsEmpty from "../../components/helpers/IsEmpty";
import ErrorMessage from "../../components/helpers/ErrorMessage";
import moment from "moment";
import PreviewImage from "../../components/common/PreviewImage/PreviewImage";

export default function AddEmployee({ match }) {
  const [jabatanList, setJabatanList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({});
  const [photoEmployee, setPhotoEmployee] = useState([]);
  const [errors, setErrors] = useState({});
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const id = match.params.id;
  const history = useHistory();

  useEffect(() => {
    getOutlet();
    getJabatan();
    if (match.params.id) {
      getEmployee();
    }
  }, []);

  useEffect(() => { }, []);

  const changeText = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const changeSelect = (opt, e) => {
    const { name } = e;
    const { value, label } = opt;
    setForm((prev) => ({
      ...prev,
      [name]: {
        label: label,
        value: value,
      },
    }));
  };

  const setDate = (name, date) => {
    console.log(date);
    setForm((prev) => ({
      ...prev,
      [name]: date,
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (IsEmpty(form.firstName)) {
      newErrors.firstName = "Nama depan tidak boleh kosong";
    }
    if (IsEmpty(form.lastName)) {
      newErrors.lastName = "Nama belakang tidak boleh kosong";
    }
    if (IsEmpty(form.birthDate)) {
      newErrors.birthDate = "Tanggal lahir tidak boleh kosong";
    }
    if (IsEmpty(form.gender)) {
      newErrors.gender = "Jenis kelamin tidak boleh kosong";
    }
    if (IsEmpty(form.phone)) {
      newErrors.phone = "No telepon tidak boleh kosong";
    }
    if (IsEmpty(form.email)) {
      newErrors.email = "Email tidak boleh kosong";
    }
    if (IsEmpty(form.address)) {
      newErrors.address = "Alamat tidak boleh kosong";
    }
    if (IsEmpty(form.outlet)) {
      newErrors.outlet = "Outlet tidak boleh kosong";
    }
    if (IsEmpty(form.jabatan)) {
      newErrors.jabatan = "Jabatan tidak boleh kosong";
    }
    if (IsEmpty(form.joinDate)) {
      newErrors.joinDate = "Tanggal mulai masuk tidak boleh kosong";
    }
    if (IsEmpty(form.status)) {
      newErrors.status = "status tidak boleh kosong";
    }
    if (IsEmpty(form.photoEmployee)) {
      newErrors.photo = "Foto tidak boleh kosong";
    }
    return newErrors;
  };

  const submit = () => {
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      let data = {
        id: id,
        first_name: form.firstName,
        last_name: form.lastName,
        email: form.email,
        phone: form.phone,
        address: form.address,
        date_of_birth: form.birthDate,
        profil_picture: form.photoEmployee,
        joined_at: form.joinDate,
        gender: form.gender,
        outlet_id: form.outlet.value,
        jabatan_id: form.jabatan.value,
        status: form.status,
      };
      console.log(data);

      setSubmitting(true);
      if (id) {
        httpclient
          .PUT(`${process.env.REACT_APP_BASE_API_URL}employee/${id}`, data)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            history.push(AppRoutePath.USERS_EMPLOYEE);
          })
          .catch((error) => {
            console.log(error.response.data);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data?.error?.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        httpclient
          .POST(`${process.env.REACT_APP_BASE_API_URL}employee`, data)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            history.push(AppRoutePath.USERS_EMPLOYEE);
          })
          .catch((error) => {
            console.log(error.response.data);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data?.error?.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data));
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getEmployee = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}employee/${id}`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        let date_of_birth = moment(response.data.data.date_of_birth).format(
          "YYYY-MM-DD"
        );
        let joined_at = moment(response.data.data.joined_at).format(
          "YYYY-MM-DD"
        );
        console.log(response.data.data);
        setForm({
          photoEmployee: response.data.data.profil_picture,
          firstName: response.data.data.first_name,
          lastName: response.data.data.last_name,
          birthDate: moment(date_of_birth).toDate(),
          gender: response.data.data.gender,
          phone: response.data.data.phone,
          email: response.data.data.email,
          address: response.data.data.address,
          outlet: {
            value: response.data.data.outlet_id,
            label: response.data.data.outlet.name,
          },
          jabatan: {
            value: response.data.data.jabatan_id,
            label: response.data.data.jabatan.name,
          },
          joinDate: moment(joined_at).toDate(),
          status: response.data.data.status,
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getJabatan = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}jabatan`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setJabatanList(convertJabatanList(response.data.data.items));
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const dragPhoto = {
    name: "file",
    multiple: false,
    onChange(info) {
      handleUploadImage(info.file);
    },
  };

  const handleUploadImage = (file) => {
    const fmData = new FormData();
    fmData.append("file", file);

    let url = `${process.env.REACT_APP_BASE_API_URL}upload-image`;
    AxiosCustomPost(
      url,
      fmData,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
        "content-type": "multipart/form-data",
      }),
      (response) => {
        message.success("Uploaded");
        setPhotoEmployee([file]);
        setForm((prev) => ({
          ...prev,
          photoEmployee: response.data.data.object_path,
        }));
      },
      (error) => {
        console.log(error.response.data);
        message.error("error");
      }
    );
  };

  // const handleOpenPreview = (src) => () => {
  //   setImgLink(src);
  //   setIsPreviewOpen(true);
  // };

  return (
    <div>
      <div className="p-3">
        {/* <form onSubmit={() => this.submit}> */}
        <h5 className="font-weight-bold">{id ? "Ubah" : "Tambah"} Pegawai</h5>
        <div className="p-3 bg-white shadow-graph rounded mx-auto">
          <div className="d-flex flex-column" style={{ fontSize: 14 }}>
            <h7 className="font-weight-semi-bold">Isi Data Pegawai</h7>
            <h7 className="pt-3 color-A6A6A6">Foto Pegawai</h7>
            <Upload.Dragger
              {...dragPhoto}
              beforeUpload={() => false}
              fileList={photoEmployee}
              className="p-3"
            >
              <p className="ant-upload-drag-icon">
                <FaLongArrowAltDown
                  style={{ fontSize: 40, color: "#F5CB58" }}
                />
              </p>
              <p className="ant-upload-text">Tarik dan letakkan foto disini</p>
              <p className="ant-upload-hint">atau</p>
              <p className="ant-upload-hint">
                <Button
                  style={{
                    border: "0.75px solid #DCDCDC",
                    borderRadius: 6,
                  }}
                >
                  Pilih Foto
                </Button>
              </p>

              <p className="ant-upload-hint">
                Format JPG, JPEG, PNG (Ukuran maksimal 1 MB)
              </p>
            </Upload.Dragger>
            {id && JSON.stringify(photoEmployee) === "[]" ? (
              <label
                className="small mt-2"
                style={{ cursor: "pointer" }}
                onClick={() => setIsPreviewOpen(true)}
              >
                {form.photoEmployee}
              </label>
            ) : null}
            <ErrorMessage error={errors.photo} />

            <div className="d-flex flex-row" style={{ fontSize: 14 }}>
              <div className="form-group p-1 mt-1 col-4">
                <label htmlFor="first_name" className="color-A6A6A6">
                  Nama Depan
                </label>
                <input
                  id="firstName"
                  type="text"
                  name="firstName"
                  className="form-control"
                  value={form.firstName}
                  onChange={changeText}
                  required
                />
                <ErrorMessage error={errors.firstName} />
              </div>
              <div className="form-group p-1 mt-1 col-4">
                <label htmlFor="last_name" className="color-A6A6A6">
                  Nama Belakang
                </label>
                <input
                  id="lastName"
                  type="text"
                  name="lastName"
                  className="form-control"
                  value={form.lastName}
                  onChange={changeText}
                  required
                />
                <ErrorMessage error={errors.lastName} />
              </div>
              <div className="form-group p-1 mt-1 col-4">
                <label htmlFor="date_of_birth" className="color-A6A6A6">
                  Tanggal Lahir
                </label>
                <div className="d-flex align-items-center">
                  <DatePicker
                    dateFormat="dd MMMM yyyy"
                    selected={form.birthDate}
                    onChange={(date) => setDate("birthDate", date)}
                    className="form-control"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  <IoCalendarOutline
                    style={{ fontSize: 20, marginLeft: -30, zIndex: 1 }}
                  />
                </div>
                <ErrorMessage error={errors.birthDate} />
              </div>
            </div>

            <div className="d-flex flex-row" style={{ fontSize: 14 }}>
              <div className="form-group p-1 mt-1 col-4">
                <label htmlFor="gender" className="color-A6A6A6">
                  Jenis Kelamin
                </label>
                <div id="gender" className="" style={{ fontSize: 16 }}>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      id="inlineRadio1"
                      onChange={changeText}
                      value="M"
                      checked={form.gender === "M"}
                    />
                    <label className="form-check-label" for="inlineRadio1">
                      Laki-laki
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      id="inlineRadio2"
                      onChange={changeText}
                      value="F"
                      checked={form.gender === "F"}
                    />
                    <label className="form-check-label" for="inlineRadio2">
                      Perempuan
                    </label>
                  </div>
                </div>
                <ErrorMessage error={errors.gender} />
              </div>
              <div className="form-group p-1 mt-1 col-4">
                <label htmlFor="phone" className="color-A6A6A6">
                  No. Telepon
                </label>
                <input
                  id="phone"
                  type="phone"
                  name="phone"
                  className="form-control"
                  value={form.phone}
                  onChange={changeText}
                  required
                />
                <ErrorMessage error={errors.phone} />
              </div>
              <div className="form-group p-1 mt-1 col-4">
                <label htmlFor="email" className="color-A6A6A6">
                  Email
                </label>
                <input
                  id="email"
                  type="text"
                  name="email"
                  className="form-control"
                  value={form.email}
                  onChange={changeText}
                  required
                />
                <ErrorMessage error={errors.email} />
              </div>
            </div>
            <div className="d-flex flex-row" style={{ fontSize: 14 }}>
              <div className="form-group p-1 mt-1 col-12">
                <label htmlFor="address" className="color-A6A6A6">
                  Alamat
                </label>
                <input
                  id="address"
                  type="text"
                  name="address"
                  className="form-control"
                  value={form.address}
                  onChange={changeText}
                  required
                />
                <ErrorMessage error={errors.address} />
              </div>
            </div>
            <div className="d-flex flex-row" style={{ fontSize: 14 }}>
              <div className="form-group p-1 mt-1 col-4">
                <label htmlFor="outlet" className="color-A6A6A6">
                  Cabang
                </label>
                <Select
                  name="outlet"
                  options={outletList}
                  onChange={changeSelect}
                  value={form.outlet}
                />
                <ErrorMessage error={errors.outler} />
              </div>
              <div className="form-group p-1 mt-1 col-4">
                <label htmlFor="jabatan" className="color-A6A6A6">
                  Jabatan
                </label>
                <Select
                  name="jabatan"
                  options={jabatanList}
                  onChange={changeSelect}
                  value={form.jabatan}
                />
                <ErrorMessage error={errors.jabatan} />
              </div>
              <div className="form-group p-1 mt-1 col-4">
                <label htmlFor="joined_at" className="color-A6A6A6">
                  Mulai Masuk
                </label>
                <div className="d-flex align-items-center">
                  <DatePicker
                    dateFormat="dd MMMM yyyy"
                    selected={form.joinDate}
                    onChange={(date) => setDate("joinDate", date)}
                    className="form-control"
                  />
                  <IoCalendarOutline
                    style={{ fontSize: 20, marginLeft: -30, zIndex: 1 }}
                  />
                </div>
                <ErrorMessage error={errors.joinDate} />
              </div>
            </div>

            <div className="form-group p-1 mt-1 col-4">
              <label htmlFor="status" className="color-A6A6A6">
                Status
              </label>
              <div id="status" className="" style={{ fontSize: 16 }}>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="status"
                    id="inlineRadio3"
                    onChange={changeText}
                    value="active"
                    checked={form.status === "active"}
                  />
                  <label className="form-check-label" for="inlineRadio3">
                    Aktif
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="status"
                    id="inlineRadio4"
                    onChange={changeText}
                    value="inactive"
                    checked={form.status === "inactive"}
                  />
                  <label className="form-check-label" for="inlineRadio4">
                    Non Aktif
                  </label>
                </div>
              </div>
              <ErrorMessage error={errors.status} />
            </div>
          </div>
        </div>
        <div className="d-flex p-3">
          <div className="ml-auto">
            <button
              onClick={submit}
              className="btn border-438EBC bgc-2C465C text-white px-4"
              type="submit"
              disabled={submitting}
            >
              <MdSave style={{ fontSize: 20 }} /> Simpan
            </button>
          </div>
        </div>
        {/* </form> */}
      </div>
      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={`employee/${id}/profil-picture`}
      />
    </div>
  );
}
